import { AsyncPipe, NgClass, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GuestPassStatus } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-guest-pass-status',
  templateUrl: './guest-pass-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe, NgClass, TitleCasePipe],
})
export class GuestPassStatusComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  /**
   * Resolves a status value (string key like "Booked" or numeric value like 1 or "1")
   * to the GuestPassStatus numeric enum value for consistent switching.
   */
  private resolveStatusValue(status: any): GuestPassStatus | null {
    if (status === null || status === undefined || status === '') return null;

    // Already a number
    if (typeof status === 'number') return status as GuestPassStatus;

    // Numeric string like "1"
    const asNumber = Number(status);
    if (!isNaN(asNumber) && asNumber > 0) return asNumber as GuestPassStatus;

    // String key like "Booked" or "NoShow"
    const enumValue = GuestPassStatus[status as keyof typeof GuestPassStatus];
    return enumValue !== undefined ? enumValue : null;
  }

  setGuestPassStatus(status: any): string {
    const resolved = this.resolveStatusValue(status);
    if (resolved === null) return status ?? '';

    // Return the enum key name (e.g. "NoShow" → "No Show" is handled in template via titlecase)
    return GuestPassStatus[resolved] ?? status;
  }

  getStatusColor(status: any): string {
    const resolved = this.resolveStatusValue(status);

    switch (resolved) {
      case GuestPassStatus.Booked:
        return 'bg-blue-400';
      case GuestPassStatus.Attended:
        return 'bg-green-400';
      case GuestPassStatus.NoShow:
        return 'bg-orange-400';
      case GuestPassStatus.Cancelled:
        return 'bg-red-400';
      default:
        return 'bg-gray-400';
    }
  }
}
